"use strict";

exports.__esModule = true;
var _InstantaneousEventController = require("./InstantaneousEventController");
Object.keys(_InstantaneousEventController).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _InstantaneousEventController[key]) return;
  exports[key] = _InstantaneousEventController[key];
});